export default function Footer() {
    return (
      <footer>
        <p>© 2026 SmileHub | Powered by SmileHub</p>
      </footer>
    );
  }
  